import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchTaskComments, addComment, updateComment, deleteComment, } from "../services/commentService";
const useComments = (taskId) => {
    const qc = useQueryClient();
    const { data, error, isLoading, refetch } = useQuery(["comments", taskId], () => fetchTaskComments(taskId), { enabled: !!taskId, staleTime: 60000 });
    const addMutation = useMutation((content) => addComment(taskId, content), { onSuccess: () => qc.invalidateQueries(["comments", taskId]) });
    const updateMutation = useMutation(({ id, body }) => updateComment(id, body), { onSuccess: () => qc.invalidateQueries(["comments", taskId]) });
    const deleteMutation = useMutation((id) => deleteComment(id), { onSuccess: () => qc.invalidateQueries(["comments", taskId]) });
    return {
        comments: data ?? [],
        loading: isLoading,
        error: error?.message ?? null,
        refetchComments: refetch,
        handleAddComment: addMutation.mutateAsync,
        handleUpdateComment: (id, body) => updateMutation.mutateAsync({ id, body }),
        handleDeleteComment: deleteMutation.mutateAsync,
    };
};
export default useComments;
